import {EventEmitter, Injectable} from "@angular/core";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {PlatformCommand, PlatformCommandResponse} from "@shared/commands/command-base";
import {take} from "rxjs/operators";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {CommandService} from "@core/services/command.service";
import {Router} from "@angular/router";
import {Api} from "@shared/constants/common-field.constants";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";
import {FileManagementService} from "@core/services/file-management.service";
import {PlatformQuery, PlatformQueryResponse} from "@shared/models/platform-query/platform-query";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {SnackBarService} from "@core/services/snack-bar.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CbCFilingHandler implements IPlatformToolHandler{
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  metaData?: any;
  currentFieldSections = [];
  currentSelectedFieldSection : any;
  currentSelectedFieldSectionIndex : any;
  fieldSectionValueEmitted = false;

  constructor(private fuseSplashScreenService : FuseSplashScreenService,
              private commandService : CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fileManagementService: FileManagementService,
              private platformQueryService: PlatformQueryService,
              private snackBarService: SnackBarService) {
                this.metaData = {};
              }

  destroy(): void {
  }

  valueChanged($event) {
    switch ($event.action.id) {
      case 'Edit':
        this.edit($event);
        break;
      case 'Refresh':
        this.refresh($event);
        break;
      case 'OpenNote':
        this.handleNoteDialogByKey($event, 'NoteDialogEditorComponent');
        break;
      case 'ShowDetails':
      case 'CbcFilingDateFiledClicked':
        this.emitFilingItem($event);
    }
  }

  private emitFilingItem($event: any) {
    if (this.isNullOrUndefined(this.metaData.cbcFilingDateFiledEventEmitter)) {
      this.metaData.cbcFilingDateFiledEventEmitter = new EventEmitter<any>(); // to listen clear event from left panel filter
    }
    this.magicLinkModel.cardHolder.isCollapsed = false;
    setTimeout(() => {
      let filingDataToEmit = {
        datefileditem: $event.item,
        fieldDefinition: $event.fieldDefinition
      };
      this.metaData.cbcFilingDateFiledEventEmitter.emit(filingDataToEmit);
    }, 50);
    
  }

  private refresh($event: any) {
      var fieldDefinitionKey = $event.fieldDefinition.key;

      if($event.item.cells[$event.fieldDefinition.key].metaData.ResetCommand){
        const command = $event.item.cells[$event.fieldDefinition.key].metaData.ResetCommand;
        this.executeCommandToApi(command);
        return;
      }

      var platformCommand = new PlatformCommand('CbcFilingDueDateUpdateCommand', Api.DueDateTracker);
      platformCommand.projectId = '[PROJECT_ID]';
      platformCommand.setValue('DueDateKey', fieldDefinitionKey);
      platformCommand.setValue('CbcFilingItemId', $event.item.id);
      platformCommand.setValue('DueDateUserInputAvailable', false);
      platformCommand.setValue('UserInputDueDate', $event.item.cells[fieldDefinitionKey].displayText);
      this.executeCommandToApi(platformCommand);
  }

  private edit($event: any) {
    if ($event.item.cells[$event.fieldDefinition.key].metaData?.Command) {
      const command = $event.item.cells[$event.fieldDefinition.key].metaData.Command;
      this.executeCommandToApi(command);
      return;
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.magicLinkModel.cardHolder.isCollapsed = true;
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    if(command.name == 'EditDateSettingsCommand'){
      this.getDateSettingsInputModel(command.projectId).pipe(take(1)).subscribe(response => {
        console.log(response);
        if (response.fieldValues['EditDateSettingsInputModel']) {
          let dateSettingsModel = response.fieldValues['EditDateSettingsInputModel'];
          this.openDateSettingDialog(command,dateSettingsModel);
        } else {
          this.snackBarService.showError('Failed to get Date Settings input Model');
        }
      },error => {
        this.snackBarService.showError('Failed to get Date Settings input Model');
      });
      return;
    }
    else {
      this.executeCommandToApi(command);
    }
  }

  private openDateSettingDialog(command,dateSettingsModel) {
    const dialogModel = DialogModel.create('Edit Date Settings', 'EditDateSettingsDialogEditorComponent', {dateSettingsModel}, '600px');
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state.action === 'OK') {
        const updateCommand = this.getEditDateSettingsCommand(command, state);
        this.executeCommandToApi(updateCommand);
      }
    });
  }

  private getEditDateSettingsCommand(command: PlatformCommand, state: any) : PlatformCommand {
    command.fieldValues['EditDateSettingsInputModel'] = state.data.input.dateSettingsModel;
    return command;
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          else if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          else if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.refreshPlatformLinkModel(commandResponse);
            return;
          }
          else if(commandResponse.fieldValues['DownloadResponse']){
            this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues['DownloadResponse'].fileId).subscribe(payload => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, `${commandResponse.fieldValues['DownloadResponse'].fileName}`);
            });
            return;
          }
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed To Execute command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }


  private refreshPlatformLinkModel(commandResponse: PlatformCommandResponse) {
    const payload = {id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel']};
    this.magicLinkModelValueChanged.emit(payload);
  }

  private handleNoteDialogByKey(event: any, componentName: string) {
    const dialogModel = DialogModel.create('More Information', componentName, {
      key : event.noteKey,
      item : event.item
    }, '400px', '600px ' , false, -1, '', '');

    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(2)).subscribe(state => {
      if (state.action === 'OK') {}
    });
  }

  private getDateSettingsInputModel(projectId: string) : any {

    var query = new PlatformQuery();
    query.name = 'CbcFilingDateSettingsInputModelPlatformQuery';
    query.api = Api.DueDateTracker;
    query.projectId = projectId;
    return this.platformQueryService.executeQuery(query);
  }
  onFieldSectionChanged?($event: any){
    console.log('asdasd');
    this.currentFieldSections = $event;
    if(!this.fieldSectionValueEmitted){
      this.sendFieldSectionChangeEvent();
    }
  }

  onFieldSectionIndexChanged?($event: any){
    this.initializeFieldSectionEmitter();
    this.currentSelectedFieldSectionIndex = $event;
    if(this.currentFieldSections.length == 0)
    {
      return ;
    }
    this.sendFieldSectionChangeEvent();
  }

  private sendFieldSectionChangeEvent() {
    this.currentSelectedFieldSection = this.currentFieldSections[this.currentSelectedFieldSectionIndex];
    this.metaData.fieldSectionInfoEmitter.next(this.currentSelectedFieldSection);
    this.fieldSectionValueEmitted = true;
  }

  private initializeFieldSectionEmitter() {
    if (this.metaData.fieldSectionInfoEmitter == null) {
      this.metaData.fieldSectionInfoEmitter = new BehaviorSubject<any>(null);
    }
  }

  isNullOrUndefined(item){
    if(item == null || item == undefined){
      return true;
    }
    return false;
  }

}
